import http from './api'
import { GolfRoomSettings } from '../types/golf'

class GolfRoomSettingsService {
  async getRoomSettings(roomId: string): Promise<GolfRoomSettings> {
    const response = await http.get(`/golf-room-settings/room/${roomId}`)
    return response.data
  }

  async updateRoomSettings(roomId: string, data: Partial<GolfRoomSettings>): Promise<GolfRoomSettings> {
    const response = await http.patch(`/golf-room-settings/room/${roomId}`, data)
    return response.data
  }
}

const golfRoomSettingsService = new GolfRoomSettingsService()
export default golfRoomSettingsService

